import React from "react";
import { Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { Add, Create } from "@mui/icons-material";
import NoReportsIcon from "./icons/NoReportsIcon";

// The placeholder is either an image URL - the original contract, still used by
// the screens that have not moved over - or one of the empty-state icons in
// ui-components/icons, passed as the component itself. The icons are vector and
// carry their own gradient border, so they render at their native 80px rather
// than being stretched into the 200px box the illustrations filled.
// `placeHolderSx` only sizes the illustrations - callers pass things like
// { width: 300 } to fit them to a panel. It is meaningless for the icons, which
// are fixed-size and self-framed, and actively harmful: spreading a width onto
// their wrapper strands the icon against its left edge while the copy below
// stays centred. So it is honoured for the image branch only.
const Placeholder = ({ image, placeHolderSx = {} }) => {
  if (!image) return null;

  if (typeof image === "function" || React.isValidElement(image)) {
    const Icon = image;
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          marginBottom: "18px",
        }}
      >
        {typeof image === "function" ? <Icon /> : image}
      </Box>
    );
  }

  return (
    <img
      src={image}
      style={{ width: '200px', height: 200, marginBottom: '20px', background: '', borderRadius: 8, ...placeHolderSx }} // Adjust the size as needed
    />
  );
};

// Shared empty-state title style, matching the NoRounds screen.
const titleStyle = {
  fontFamily: 'Lato',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '16.5px',
  lineHeight: 1,
  letterSpacing: 0,
};

const NoData = ({ Actions = () => { }, sx = {}, placeHolderImage, placeHolderSx = {}, title = "No Data", subTitle = "", height = "60dvh", titleSx = {} }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Box
      // display="flex"
      display="grid"
      // flexDirection="column"
      // alignItems="center"
      justifyContent="center"
      minHeight="calc(100% - 164px)"
      textAlign="center"
      padding={3}
      sx={{ placeItems: "center", placeContent: 'center', ...sx }}
      height={height}
      // height={"100%"}
      width={"-webkit-fill-available"}
    // width={"100%"}
    >
      <Placeholder image={placeHolderImage ?? NoReportsIcon} placeHolderSx={placeHolderSx} />


      {
        title ?
          typeof title === "string" ?
            (title?.length > 0 ? <Typography sx={{ marginBottom: "28px",  ...titleStyle, ...titleSx }}>
              {title}
            </Typography> : <></>) : <Typography sx={{ marginBottom: "28px",  ...titleStyle, ...titleSx }}>
              {title}
            </Typography> : <></>
      }

      {
        subTitle ?
          typeof subTitle === "string" ?
            (subTitle?.length > 0 ? <Typography variant="body1" marginBottom={2} gutterBottom>
              {subTitle}
            </Typography> : <></>) : <Typography variant="body1" marginBottom={2} gutterBottom>
              {subTitle}
            </Typography> : <></>
      }


      

      <Actions />
    </Box>
  );
};

export default NoData;